import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { themePalette } from "../../../constants/Theme/colors";
import { monthsList } from "../../../constants/staticData/monthlyList";
import { daysList } from "../../../constants/staticData/daysList";

const UserAdminGraph = props => {
  const { info, interval, startWeek, endWeek, monthInfo, yearInfo } = props;
  const [yearData, setYearData] = useState(monthsList);
  const [monthData, setMonthData] = useState(daysList);
  const [weekData, setWeekData] = useState([]);
  const [dateList, setDateList] = useState([]);

  const startWeekDate = new Date(startWeek);
  const startEndDate = new Date(endWeek);

  useEffect(() => {
    if (interval == "Yearly") {

      setYearData(monthsList);
      if (info?.length > 0) {
        info.map(item2 => {
          setYearData(prev =>
            prev.map(item => {
              if (item?.value == item2?.month) {
                return {
                  ...item,
                  dataset: [item2?.users],
                };
              }
              return item;
            })
          );
        });
      }
    } else if (interval == "Monthly") {

      setMonthData(daysList);
      if (info?.length > 0) {
        info.map(item2 => {
          setMonthData(prev =>
            prev.map(item => {
              if (item?.value == new Date(item2?.date).getDate()) {
                return {
                  ...item,
                  dataset: [item2?.users],
                };
              }
              return item;
            })
          );
        });
      }
    } else if (interval == "Weekly") {

      const filterWeek = [];
      dateList.map(item => {
        filterWeek.push({ id: item, value: null });
      });
      setWeekData(filterWeek);

      if (info?.length > 0) {
        info.map(item2 => {
          setWeekData(prev =>
            prev.map(item => {
              if (item?.id == item2?.date) {
                return {
                  ...item,
                  value: item2?.users,
                };
              }
              return item;
            })
          );
        });
      }
    }
  }, [info, interval]);

  useEffect(() => {
    const allDates = [];
    for (
      var day = startWeekDate;
      day <= startEndDate;
      day.setDate(day.getDate() + 1)
    ) {
      allDates.push(day.getDate());
    }
    setDateList(allDates);
  }, [startWeek, endWeek]);

  const getChartData = () => {
    if (interval === "Yearly") {
      return yearData.map(val =>
        val?.dataset?.length && val?.dataset[0] !== undefined
          ? val?.dataset[0]
          : null
      );
    } else if (interval === "Monthly") {
      return monthData
        .slice(0, new Date(yearInfo, monthInfo, 0).getDate())
        .map(val =>
          val?.dataset?.length && val?.dataset[0] !== undefined
            ? val?.dataset[0]
            : null
        );
    } else if (interval === "Weekly") {
      return weekData.map(item => (item?.value !== null ? item?.value : null));
    }
    return [];
  };

  return (
    <Box sx={{ mt: 3, width: "100%" }}>
      <Chart
          width="100%"
          height="360px"
          options={{
            chart: {
              type: "line",
              zoom: {
                enabled: false,
              },
              toolbar: {
                show: false,
              },
              parentHeightOffset: 0,
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: "straight",
              width: 1,
            },
            grid: {
              row: {
                colors: ["transparent"],
                opacity: 0.5,
              },
              padding: {
                left: 13,
                right: 0,
              },
            },
            xaxis: {
              axisBorder: {
                show: true,
                color: "#d4d4d4",
                offsetX: 0,
                offsetY: 0,
              },
              title: {
                text:
                  ({ Yearly: "Months", Monthly: "Days", Weekly: "Date" }[interval] || ""),
                offsetY: -5,
                style: {
                  color: themePalette.palette.text.secondary,
                  fontSize: "12px",
                  fontWeight: 500,
                },
              },
              categories:
                interval == "Yearly"
                  ? yearData.map(val => val?.label)
                  : interval == "Monthly"
                  ? monthData
                      .slice(0, new Date(yearInfo, monthInfo, 0).getDate())
                      .map(val => val?.label)
                  : interval == "Weekly"
                  ? dateList.map(val => val)
                  : "",
              labels: {
                rotate: -45,
                rotateAlways: false,
                hideOverlappingLabels: true,
                trim: false,
                style: {
                  fontSize: "11px",
                },
              },
              tickAmount: interval == "Weekly" ? Math.min(dateList.length, 10) : undefined,
            },
            yaxis: {
              show: true,
              min: 0,
              title: {
                text: "Users",
                offsetX: 0,
                style: {
                  color: themePalette.palette.text.secondary,
                  fontSize: "12px",
                  fontWeight: 500,
                },
              },
              axisBorder: {
                show: true,
                color: "#d4d4d4",
                offsetX: 0,
                offsetY: 0,
              },
              labels: {
                minWidth: 50,
                formatter: function (val) {
                  return Number.isInteger(val) ? val : "";
                },
              },
            },
            markers: {
              size: 6,
            },
          }}
          series={[
            {
              name: "Users",
              data: getChartData(),
            },
          ]}
        />
    </Box>
  );
};

export default UserAdminGraph;
